// extracted by mini-css-extract-plugin
export default {"button":"IndexSideButton_button__4hWWt"};